import { render, staticRenderFns } from "./DisplayCheckbox.vue?vue&type=template&id=4be0145c"
import script from "./DisplayCheckbox.vue?vue&type=script&lang=js"
export * from "./DisplayCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports